<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="800">
        <v-card tile :disabled="loading" :loading="loading">
            <v-toolbar dark dense>
                <v-toolbar-title>
                    DIAGNÓSTICO DEFINITIVO (ICD)
                </v-toolbar-title>

                <v-spacer />

                <v-toolbar-items>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pt-4">
                <v-row dense>
                    <v-col cols="11">
                        <v-autocomplete v-model="icd" :items="icds" :item-text="(item) => `${item.code} | ${item.icd}`"
                            :loading="icds_loading" label="Descripción" return-object dense />
                    </v-col>

                    <v-col cols="1">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" block dark small color="orange darken-2" @click="icdAdd">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>

                            <span>Agregar</span>
                        </v-tooltip>
                    </v-col>

                    <v-col cols="12">
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th width="50">#</th>
                                        <th width="70">Código</th>
                                        <th>Descripción</th>
                                        <th width="50" />
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, i) in active_icds"
                                        :key="item.id ? item.id : `new-${item.icd_id}`">
                                        <td v-text="i + 1" />
                                        <td v-text="item.code" />
                                        <td v-text="item.icd" />

                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" text icon x-small color="error"
                                                        @click="icdRemove(item, i)">
                                                        <v-icon medium>mdi-close</v-icon>
                                                    </v-btn>
                                                </template>

                                                <span v-text="`Eliminar ICD (${i + 1})`" />
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>

                    <v-col cols="12">
                        <v-btn block color="success" @click.prevent="submit">
                            Guardar
                            <v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Axios from "axios";
import {
    URL_API,
    headersToken,
    msgAlert,
    msgConfirm,
} from "../../control";

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },

        rsId: {
            type: Number,
            required: true,
        },

        rsIcds: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            login: this.$store.getters.getLogin,
            loading: false,

            icds: [],
            icds_loading: false,
            icd: null,

            items: [],
        };
    },

    computed: {
        dialog: {
            get() {
                return this.value;
            },

            set(value) {
                this.$emit("input", value);
            },
        },

        active_icds() {
            return this.items.filter((item) => item.active);
        },
    },

    watch: {
        value(value) {
            if (value) {
                this.items = this.rsIcds.map((item) => ({
                    ...item,
                }));

                this.icd = null;

                if (this.icds.length === 0) {
                    this.getIcds();
                }
            }
        },
    },

    methods: {
        getIcds() {
            this.icds_loading = true;

            Axios.get(
                `${URL_API}/catalog?name=icds&no_order=false`,
                headersToken(this.login.token),
            ).then((response) => {
                this.icds = response.data.data;
                this.icds_loading = false;
            });
        },

        icdAdd() {
            if (!this.icd) {
                this.$swal.fire(
                    msgAlert("error", "Selecciona una descripción de ICD"),
                );

                return;
            }

            const exists = this.items.some(
                (item) =>
                    item.icd_id == this.icd.id &&
                    item.active,
            );

            if (exists) {
                this.$swal.fire(
                    msgAlert("warning", "El ICD seleccionado ya ha sido agregado"),
                );

                return;
            }

            this.items.push({
                id: null,
                icd_id: this.icd.id,
                code: this.icd.code,
                icd: this.icd.icd,
                active: true,
            });

            this.icd = null;
        },

        icdRemove(item, i) {
            this.$swal
                .fire(msgConfirm(`¿Confirma eliminar ICD (${i + 1})?`))
                .then((response) => {
                    if (response.isConfirmed) {
                        if (item.id) {
                            item.active = false;
                        } else {
                            const index = this.items.indexOf(item);

                            if (index >= 0) {
                                this.items.splice(index, 1);
                            }
                        }
                    }
                });
        },

        submit() {
            this.$swal
                .fire(msgConfirm("¿Confirma actualizar los ICD?"))
                .then((response) => {
                    if (response.isConfirmed) {
                        this.loading = true;

                        Axios.patch(
                            `${URL_API}/rss/${this.rsId}/icds`,
                            {
                                icds: this.items,
                            },
                            headersToken(this.login.token),
                        ).then((response) => {
                            this.$swal.fire(
                                msgAlert(
                                    response.data.success ? "success" : "error",
                                    response.data.message,
                                ),
                            );

                            if (response.data.success) {
                                this.dialog = false;
                                this.$emit("updated");
                            }

                            this.loading = false;
                        });
                    }
                });
        },
    },
};
</script>